import React, { useState } from 'react';

const FancyCheckbox = ({ checked, onChange, index, name }) => {
  return (
    <div style={{ display: 'inline-block' }}>
      <input
        type="checkbox"
        id={`cbx-${index}`}
        checked={checked}
        onChange={() => onChange(name)}
        style={{ display: 'none', visibility: 'hidden' }}
      />
      <label
        htmlFor={`cbx-${index}`}
        style={{
          margin: 'auto',
          userSelect: 'none',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            position: 'relative',
            width: '18px',
            height: '18px',
            borderRadius: '3px',
            border: '1px solid #9098a9',
            display: 'inline-block',
            verticalAlign: 'middle',
            transition: 'all 0.2s ease',
            backgroundColor: checked ? '#506eec' : 'white',
            animation: checked ? 'wave-46 0.4s ease' : 'none',
          }}
        >
          <svg
            viewBox="0 0 12 10"
            height="10px"
            width="12px"
            style={{
              position: 'absolute',
              top: '3px',
              left: '2px',
              fill: 'none',
              stroke: '#ffffff',
              strokeWidth: '2',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: '16px',
              strokeDashoffset: checked ? '0' : '16px',
              transition: 'all 0.3s ease 0.1s',
              pointerEvents: 'none',
            }}
          >
            <polyline points="1.5 6 4.5 9 10.5 1" />
          </svg>
        </span>
        <span style={{ paddingLeft: '8px' }}></span>
      </label>

      <style>
        {`
          @keyframes wave-46 {
            50% {
              transform: scale(0.9);
            }
          }
        `}
      </style>
    </div>
  );
};
export default FancyCheckbox;